import React, { useState } from "react";

import { LoadingSpinner } from "../partials/LoadingSpinner";
import { EmptyData } from "../../Global/EmptyData/EmptyData";

import "./WidgetNotifications.css";

export const WidgetNotifications = (props) => {
  // const [notifications, setNotifications] = useState([
  //   {
  //     content: "Treshold limit is reached for Germany",
  //     reachedLimit: true,
  //   },
  //   {
  //     content: "You will reach treshold limit for Spain soon",
  //     reachedLimit: false,
  //   },
  //   {
  //     content: "You will reach treshold limit for Italy soon",
  //     reachedLimit: false,
  //   },
  // ]);

  const [notifications] = useState([
    {
      content: "Treshold limit is reached for Germany",
      reachedLimit: true,
    },
    {
      content: "You will reach treshold limit for Spain soon",
      reachedLimit: false,
    },
    {
      content: "You will reach treshold limit for Italy soon",
      reachedLimit: false,
    },
  ]);

  // useEffect(() => {
  //   setNotifications([...notifFromBe])

    // const generateString = () => {
    //   let resultString = "/?";
    //   const querryString = {
    //     from:
    //       (props.filterPayload && props.filterPayload.from) &&
    //       props.filterPayload.from.getFullYear() +
    //         "-" +
    //         ( props.filterPayload.from.getMonth() + 1) +
    //         "-" +
    //         props.filterPayload.from.getDate(),
    //     to:
    //     (props.filterPayload && props.filterPayload.to) &&
    //     props.filterPayload.to.getFullYear() +
    //         "-" +
    //         ( props.filterPayload.to.getMonth() + 1) +
    //         "-" +
    //         props.filterPayload.to.getDate(),
    //   };

    //   //eslint-disable-next-line
    //   Object.entries(querryString).map(([fieldItem, fieldItemValue]) => {
    //     if (fieldItemValue !== undefined && fieldItemValue !== null) {
    //       return (resultString = resultString.concat(`${fieldItem}=${fieldItemValue}&`));
    //     }
    //   });

    //   return resultString;
    // };

    
  // }, [notifications, props.filterPayload])

  const listOfNotifications = () => {
    return notifications.map((item, index) => {
      return (
        <div
          key={index}
          className={"WidgetNotifications__item" + (item.reachedLimit ? " limit" : "")}
        >
          {item.content}
        </div>
      );
    });
  };

  const notifCommingSoon = () => {
    return <EmptyData title='Notifications coming soon' type='messages'/>
  };

  const isNotificationsLoaded = () => {
    return notifications.length > 0 ? (
      // listOfNotifications()
      notifCommingSoon()
      ) : (
        <LoadingSpinner/>
      )
  };

  return (
    <div
      className={
        "widget " +
        (props.width ? props.width : "")
      }
    >
      <h2 className={(props.hideTitle ? props.hideTitle : "")} > Notifications </h2>
      <div
        className={
          "WidgetNotifications " + (props.width ? "widget-content" : "") + " " + (props.border ? props.border : "")
        }
      >
        {isNotificationsLoaded()}
      </div>
    </div>
  );
};
